var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM15 5C17.75 5 20 7.75 20 11.25C20 14.75 17.75 17.5 15 17.5C12.25 17.5 10 14.75 10 11.25C10 7.75 12.25 5 15 5ZM23.25 24.375C21.125 26.25 18.125 27.5 15 27.5C11.875 27.5 8.875 26.25 6.75 24.375C6.25 23.875 6.125 23.125 6.625 22.625C8 21 9.875 19.875 11.875 19.25C12.875 19.75 13.875 20 15 20C16.125 20 17.125 19.75 18.125 19.25C20.25 19.875 22 21 23.375 22.625C23.875 23.125 23.875 23.875 23.25 24.375Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ab0e59ad.svg";
export { ForwardRef as ReactComponent };